import React, { memo, useEffect, useRef } from 'react';

import { makeStyles } from '~/UIKit/Style';
import { TIME_WIDTH } from '~/Screens/Calendar/constants';
import { WHITE } from '~/Constants/Colors.constants';
import { BOX_SHADOW_UNDERLINE } from '~/Constants/CSS.constants';
import {
  CalendarDragLayer,
  DraggableType,
  IGetEventPosition,
} from '~/Screens/Calendar/CalendarView/components';
import { ICalendarOffset } from '~/Screens/Calendar/interfaces';

const useStyles = makeStyles(
  () => ({
    headerContainer: {
      marginTop: 10,
      minHeight: 'min-content',
      padding: '0',
      display: 'flex',
      flexGrow: 0,
      alignItems: 'center',
      position: 'relative',
      overflow: 'hidden auto',
      transform: `translate(${TIME_WIDTH}px)`,
      maxWidth: `calc(100% - ${TIME_WIDTH}px)`,
      justifyContent: 'flex-start',
      backgroundColor: WHITE,
      boxShadow: BOX_SHADOW_UNDERLINE,
    },
    dragLayerContainer: {
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      position: 'absolute',
    },
  }),
  { name: 'CalendarViewHeader' },
);

interface ICalendarDayHeader {
  offset: ICalendarOffset;
  children: React.ReactNode;
  headerOffset: ICalendarOffset;
  setHeaderOffset: React.Dispatch<React.SetStateAction<ICalendarOffset>>;
  getEventPosition: IGetEventPosition;
}

export const CalendarHeaderContainer = memo(
  ({ offset, children, headerOffset, setHeaderOffset, getEventPosition }: ICalendarDayHeader) => {
    const { classes } = useStyles();
    const headerRef = useRef<null | HTMLDivElement>(null);

    useEffect((): void | (() => void) => {
      if (!headerRef.current) {
        return;
      }
      const { offsetWidth: width, offsetHeight: height } = headerRef.current;
      setHeaderOffset({
        width,
        height,
        left: 0,
        top: headerRef.current.querySelector('[class*="weekday"]')?.scrollHeight ?? 62,
      });
    }, [headerRef, offset]);

    return (
      <div className={classes.headerContainer} ref={headerRef}>
        {children}
        <div className={classes.dragLayerContainer}>
          <CalendarDragLayer
            offset={headerOffset}
            calendarType={DraggableType.FULL_DAY_ACTIVITY}
            getEventPosition={getEventPosition}
          />
        </div>
      </div>
    );
  },
);
